import { useCallback, useEffect, useRef, useState } from "react"

const ONE_MINUTE_MS = 60_000

export default function useMinuteTicker() {
  const [lastTickTime, setLastTickTime] = useState(null)
  const intervalIdRef = useRef(null)

  const startTicker = useCallback(() => {
    if (!intervalIdRef.current) {
      intervalIdRef.current = setInterval(() => {
        setLastTickTime(Date.now())
      }, ONE_MINUTE_MS)
    }
  }, [])

  const stopTicker = useCallback(() => {
    if (intervalIdRef.current) {
      clearInterval(intervalIdRef.current)
      intervalIdRef.current = null
    }
  }, [])

  useEffect(() => {
    // Make sure to stop the ticker when the component unmounts
    return () => {
      if (intervalIdRef.current) {
        clearInterval(intervalIdRef.current)
        intervalIdRef.current = null
      }
    }
  }, [])

  return { lastTickTime, startTicker, stopTicker }
}
